/* eslint-disable @typescript-eslint/naming-convention */
import 'reflect-metadata';
import {Entity} from '../../core/main.entity';
import {Type} from 'class-transformer';
import {BlockElementType} from '../enums';
import {BlockElementContainer, BlockElementLabel} from './blockElementContainer';
import {BlockElementGallery} from './blockElementGallery';
import {BlockElementWorker} from './blockElementWorker';
import {BlockElementImage} from './blockElementImage';
import {BlockElementIcon} from './blockElementIcon';
import {BlockElementArticle} from './blockElementAritlce';
import {BlockElementGroup} from './blockElementGroup';
import {BlockElementButton} from './blockElementButton';
import {BlockElement} from './blockElement';

export class BlockElements extends Entity {

  @Type(() => Entity, {
    discriminator: {
      property: 'type',
      subTypes: [
        {value: BlockElementContainer, name: 'basic'},
        {value: BlockElementContainer, name: 'empty'},
        {value: BlockElementContainer, name: 'card'},
        {value: BlockElementLabel, name: 'label'},
        {value: BlockElementGallery, name: 'gallery'},
        {value: BlockElementGroup, name: 'group'},
        {value: BlockElementWorker, name: 'worker'},
        {value: BlockElementArticle, name: 'article'},
        {value: BlockElementButton, name: 'button'},
        {value: BlockElementIcon, name: 'icon'},
        {value: BlockElementImage, name: 'image'}
      ],
    },
    keepDiscriminatorProperty: true
  })
  items: Blocks[] = [];

}

export type Blocks =
  BlockElementContainer
  | BlockElementImage
  | BlockElementIcon
  | BlockElementGallery
  | BlockElementGroup
  | BlockElementArticle
  | BlockElementButton
  | BlockElementLabel
  | BlockElementWorker;
